import Vue from 'vue';
import getEnv from './get-env';
export var isServer = Vue.prototype.$isServer;

if (isServer) {
  Vue.prototype.$isSSR = true;
}

export var UMS_URL = 'https://ums.gaoding.com';
export var REQUEST_URL = '';
export function isSSR() {
  return Vue.prototype.$isServer || Vue.prototype.$isSSR;
}

if (!isServer) {
  var env = getEnv(location.origin);

  if (/localhost/.test(location.origin)) {
    // REQUEST_URL = '';
    UMS_URL = 'http://ums.dev.gaoding.com';
  } else if (env === 'production') {
    // REQUEST_URL = 'https://www.gaoding.com';
    UMS_URL = 'https://ums.gaoding.com';
  } else if (env === 'release') {
    // REQUEST_URL = 'https://stage.gaoding.com';
    UMS_URL = 'https://ums.gaoding.com';
  } else if (env === 'localhost') {
    // REQUEST_URL = 'http://www.gaoding.localhost';
    UMS_URL = 'http://ums.dev.gaoding.com';
  } else {
    // REQUEST_URL = 'http://www.dev.gaoding.com';
    UMS_URL = 'http://ums.dev.gaoding.com';
  }
}